<template>
    <div>          
        <h1>Commandes à livrer aujourd'hui</h1>

        <div v-if="offers.length > 0" class="row mt-2">
            <div v-for="offer in offers" :key="offer.id" :offer="offer" class="col-md-4 py-2">
                <div 
                    class="box px-1 py-1"
                    v-bind:class="[{ 'quote-bg': offer.offerstatus_id === 1 }, 
                                    { 'preparation-bg': offer.offerstatus_id === 2 }, 
                                    { 'delivery-bg': offer.offerstatus_id === 3 },
                                    { 'delivered-bg': offer.offerstatus_id === 4 }]"
                >
                    <div class="px-1 py-1 bg-white" style="height: 10.5rem;">
                        <h3 class="my-1">
                            <a v-bind:href="'/customer/' + offer.customer_id + '/show'">{{offer.customer_lastname}}</a>
                        </h3>
                        <div class="my-0 font-weight-bold"><a v-bind:href="'/offer/' + offer.id + '/show'">{{offer.id}}</a></div>
                        <div class="text-nowrap overflow-hidden">{{offer.name}}</div>
                        <div><b>Statut: </b>{{offer.offerstatus_name}}</div>
                        <div><b>Livraison: </b>{{fullCity(offer)}}</div>
                        <div v-show="offer.offerstatus_id === 2" v-on:click="promote(offer.id, 3)" class="btn btn-primary btn-sm mt-2">Passer à Prête</div>
                        <div v-show="offer.offerstatus_id === 3" v-on:click="promote(offer.id, 4)" class="btn btn-primary btn-sm mt-2">Passer à Livrée</div>
                    </div>
                </div>
            </div>
        </div>
        <p v-else class="no-data">Aucune commande pour aujourd'hui</p>
    </div>
</template>

<script>
    export default {
        created() {
            this.read();
        },
        data() {
            return {
                offers: []
            }
        },
        methods: {
            read() {
                let options = {
                    sortBy: 'deliveryDate',
                    maxOfferstatusId: 3,
                    days: 'today'
                };
                window.axios.post('/offer/offersList', {options: options}).then(response => {
                    this.offers = response.data.offers;
                }).catch(error => {
                    return [];
                });
            },
            fullCity(offer){
                if(offer.pickup){
                    return('Retrait');
                }else if(offer.delivery_address){
                    return(offer.city);
                }else{
                    return(offer.customer_city);
                }
            },
            promote(id, target_offerstatus_id) {
                window.axios.post('/offer/promote', {id: id, target_offerstatus_id: target_offerstatus_id}).then(response => {
                    if(typeof response.data.offer != "undefined"){
                        var offer = this.offers.find(offer => offer.id === id);
                        offer.offerstatus_id = response.data.offer.offerstatus_id;
                        offer.offerstatus_name = response.data.offer.offerstatus.name;
                    }else if(typeof response.data.errors != "undefined"){
                        if(response.data.errors.length > 1){
                            var message = '';
                            response.data.errors.forEach(function(error) { message += '- ' + error + '\n' });
                            alert(message);
                        }else{
                            alert(response.data.errors[0]);
                        }

                    }
                })
            }
        }
    }
</script>